export enum AuthCodeErrorCode {
  NOT_FOUND = 'NOT_FOUND',
  EXPIRED = 'EXPIRED',
  REVOKED = 'REVOKED',
  USED = 'USED',
}
